const platform = {
    OS: 'web',
};
if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    // Running in React Native
    platform.OS = 'native';
}
else if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    // Running in a web browser
    platform.OS = 'web';
}
else {
    // Other environment (e.g., Node.js)
    platform.OS = 'node';
}
export const Platform = platform;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxhdGZvcm0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvcGxhdGZvcm0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxRQUFRLEdBQUc7SUFDZixFQUFFLEVBQUUsS0FBa0M7Q0FDdkMsQ0FBQztBQUVGLElBQUksT0FBTyxTQUFTLEtBQUssV0FBVyxJQUFJLFNBQVMsQ0FBQyxPQUFPLEtBQUssYUFBYSxFQUFFLENBQUM7SUFDNUUsMEJBQTBCO0lBQzFCLFFBQVEsQ0FBQyxFQUFFLEdBQUcsUUFBUSxDQUFDO0FBQ3pCLENBQUM7S0FBTSxJQUFJLE9BQU8sTUFBTSxLQUFLLFdBQVcsSUFBSSxPQUFPLFFBQVEsS0FBSyxXQUFXLEVBQUUsQ0FBQztJQUM1RSwyQkFBMkI7SUFDM0IsUUFBUSxDQUFDLEVBQUUsR0FBRyxLQUFLLENBQUM7QUFDdEIsQ0FBQztLQUFNLENBQUM7SUFDTixvQ0FBb0M7SUFDcEMsUUFBUSxDQUFDLEVBQUUsR0FBRyxNQUFNLENBQUM7QUFDdkIsQ0FBQztBQUVELE1BQU0sQ0FBQyxNQUFNLFFBQVEsR0FBRyxRQUFRLENBQUMifQ==